<template>
	<div class="container">
		<payoff
			:subtitle="`Scopri chi siamo e come investire in Quomi tramite la campagna di equity crowdfunding`"
			@openVideo="openVideo()"
		/>

		<div class="">
			<our-results
	        	id="results"
	        />
			<collaboration
				id="collaboration"
			/>
			<section id="team">
				<h2 class="center">Scopri il Team Quomi</h2>
				<p  class="content center">Quomi nasce nel 2016, quando Andrea e Daniele scoprono che hanno un problema: mangiano sempre le stesse ricette e non hanno mai tempo di fare la spesa! Si chiedono quindi: perché non risolvere questo problema a tutte le persone che come noi vogliono mangiare nuove ricette sfiziose ogni settimana e spedir loro tutto ciò che serve per prepararle? Detto, fatto!<br><br></p>
				<div class="flex-vcenter">
					<usp :template="'team'">
						<template slot="titles">
							<h2 class="center">{{ $t("components.usp.team.title") }}</h2>
						</template>
					</usp>
				</div>
				<SliderQ
	                :minSizeOfSlide='120'
	                :maxNumSlides='6'
	                v-if="team"
	                isCentered
	            >
	            	<slide v-for="(person, index) in team">
		            	<div
		            		class="center"
						>
							<div class="img-container">
								<img :src="require('../assets/img/team/' + person.img)" :alt="person.name">
							</div>
					
							<div class="team-name"><b>{{ person.name }}</b></div>
							<div class="title-container">
								<div class="team-title">{{ person.title }}</div>
							</div>
						</div>
					</slide>
	        	</SliderQ>
			</section>
				
			<why-to-choose
				noSubtitle
			/>
			<how-quomi-works
				id="how"
			/>
			<section v-if="menu && menu.recipes.length > 0">
				<h2 class="center">Il menù di questa settimana</h2>
				<SliderQ
	                :minSizeOfSlide="170"
	                :numberOfSlides='4'
	                isCentered
	            >
	            	<slide  v-for="(recipe, index) in menu.recipes">
		                <recipe-box
		                    :item="recipe"
		                    :isHover="false"
		                    :isLink="false"
		                    isBoxWithLink
		                />
		            </slide>
	            </SliderQ>
	        </section>
	       
			<what-they-say />
			<div id="more" />
			<section id="join">
				<div class="overlay" />
				<div class="content">
					<h2 class="center">Partecipa anche tu alla crescita di Quomi</h2>
					<p class="center">Scopri tutti i dettagli e investi su Crowdfundme</p>
				
						<a href="https://www.crowdfundme.it/projects/quomi/" target="_blank">
							<CTA
								:content="`Investi ora`"
							/>
						</a>
						
					<br>
					<br>
					<br>
				</div>
			</section> 
		</div>

		<transition
			name="modal-on"
			:style="[$_appViewPosition_positionTop, $_appViewPosition_positionBottom]"
		>
			<div class="modal-overlay flex-center" v-if="showVideo" @click="showVideo = false">
				<div
					@click.stop
					class="video-container"
				>
					<div class="video-inner">
						<iframe src="https://www.youtube.com/embed/KjlLTTy2YFI" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
					</div>
				</div>
			</div>
		</transition>
	</div>
</template>

<script type = "text/javascript" >
import { newsletter } from '../mixins/newsletter'

import WhatTheySay from './Parts/WhatTheySay'

import WhyToChoose from './Parts/WhyToChoose'

import RecipeBox from './RecipeBox'
import HowQuomiWorks from './Parts/HowQuomiWorks'
import Usp from './Usp'

import OurResults from './Parts/OurResults'
import Payoff from './Parts/Payoff'
import Collaboration from './Parts/Collaboration'

import { RecipeApi } from '../api/RecipeApi'
import { Recipe } from '../core/Recipe'
import { Menu } from '../core/Menu'

import { WeekPlanApi } from '../api/WeekPlanApi'
import { team } from '../data/team'
export default {

	data () {
		return {
			menu: null,
			recipes: null,

			email: null,

			team: team,

			showVideo: false
		}
	},

	components: {
		WhatTheySay,
		WhyToChoose,
		HowQuomiWorks,
		OurResults,
		Collaboration,
		Payoff,
		RecipeBox,
		Usp
	},

	mixins: [
		newsletter
	],

	methods: {
		load () {
			var wm = new WeekPlanApi()

			return wm.current({}).then(response => {
				this.recipes = new Menu(response.body.data.resource).recipes
				this.menu = new Menu(response.body.data.resource)
			}).catch(response => {
			})
		},

		openVideo () {
			this.showVideo = true
		}
	},

	mounted () {
		this.load()
	}
}

</script>

<style scoped>

.content {
	max-width: 1200px;
}

.modal-overlay {
	width: 100%;
	height: 100vh;
	background-color: rgba(0,0,0,0.5);
	position: fixed;
	top: 0;
	left: 0;
	z-index: 99999;
}

.video-container {
	width: 90%;
	max-width: 800px;
	background-color: black;
}

.video-inner {
	width: 100%;
	height: 1px;
	padding-bottom: 56.25%;
	position: relative;
}

iframe {
	width: 100%;
	height: 100%;
	position: absolute;
	top: 0;
	left: 0;
}

section {
	padding: 40px 30px;
}

input {
	margin: 0 auto 10px auto;
	flex-grow: 1;
	max-width: 300px;
}

ul {
	padding-left: 20px;
}

form {
	text-align: center;
}

.flash {
	margin: 10px auto 0 auto;
}

.error {
	color: tomato;
}

.success {
	color: green;
}

.team-name {
	padding-top: 10px;
}

#join {
	background: url("../assets/img/covers/quomi-team.jpg") center 58% no-repeat;
	display: flex;
	justify-content: flex-end;
	flex-direction: column;
	position: relative;
	padding: 200px 0 0 0;
}

#join .overlay {
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	background-color: rgba(255,255,255,0.75);

}

#join .content {
	position: relative;
	padding: 0 10px;
}

#payoff >>> h1 {
	font-size: 50px;
}

#payoff >>> h2 {
	font-size: 24px;
    font-weight: 300;
}

#join h2 {
	font-size: 50px;
}

#join p {
	font-size: 30px;
}

#join .btn {
	margin: 0 auto;
}

@media (max-width: 1024px) {
}

@media only screen and (max-width: 768px) {
	.is-simple  {
		border-bottom: 0
	}

	#join h2 {
		font-size: 30px;
	}
	#join p {
		font-size: 20px;
	}
}

</style>
